import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { routeLoaderApiClient } from "@/lib/api";
import { Link, createFileRoute } from "@tanstack/react-router";
import { formatOrganisationNumber } from "@terralux/common/string";

export const Route = createFileRoute("/_authenticated-user/superuser/afpant/")({
  loader: async () => {
    const res = await routeLoaderApiClient.superuser.organisation.$get();

    if (res.ok === false) {
      throw new Error("Failed to fetch messages");
    }

    return {
      organisations: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Superuser AFPANT | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { organisations } = Route.useLoaderData();

  return (
    <>
      <DocumentTitle>Superuser AFPANT</DocumentTitle>

      <ul>
        {organisations.map((organisation) => (
          <li key={organisation.orgNumber}>
            <Link to="/superuser/afpant/$orgNumber" params={{ orgNumber: organisation.orgNumber }}>
              {organisation.name} ({formatOrganisationNumber(organisation.orgNumber)})
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}
